import styled from "styled-components";
import { colors } from "../../../../styles/colors";

export const ItemContainer = styled.div`
  position: relative;
  direction: rtl;

  .option-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .option-title {
      font-size: 10px;
      color: ${colors.blue};
    }

    .option-value {
      font-size: 10px;
      color: ${colors.darkBlue};
    }
  }

  .option-content {
    margin-top: 8px;
    margin-bottom: 20px;

    .progress-bar {
      width: 100%;
      height: 5px;
      background-color: ${colors.blueGray};
      border-radius: 25px;
      overflow: hidden;

      .progress-fill {
        height: 100%;
        background-color: ${colors.blue};
        border-radius: 25px;
        transition: width 1.5s cubic-bezier(0.4, 0, 0.2, 1);

        &.animate {
          animation: progressFill 1.5s ease-out;
        }
      }
    }
  }

  @keyframes progressFill {
    from {
      width: 0%;
    }
    to {
      width: var(--progress-width, 0%);
    }
  }
`;
